import { wodChoresGarrison } from './garrisons';

export const wodTasks = [wodChoresGarrison];
